import React from 'react';
import { Typography, Button, Card, CardActions, useMediaQuery, Link } from '@mui/material';
import { Image } from 'cloudinary-react'
import { useDispatch, useSelector } from "react-redux"
import { useTheme } from '@mui/material/styles';
import { toast } from 'react-hot-toast';
import { useGetCartQuery, useGetUserFavoritesQuery, useUpdateCartMutation, useUpdateFavoriteMutation } from '../../features/fullApi';
import { addToCart } from '../../features/slices/cartSlice';
import { removeFromFavorite } from '../../features/slices/favoriteSlice';



const FavoriteItem = ({item}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const dispatch = useDispatch()
  const [updateCart] = useUpdateCartMutation()

  console.log("ITEM IS", item)

  const [updateFavorite] = useUpdateFavoriteMutation()

  const {data: cart, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user?._id);
  const {data: favorite, error: favoriteError, isLoading: favoriteIsLoading} = useGetUserFavoritesQuery(user?._id)
 
  const handleRemoveFromFavorite = (favoriteItem) => {
    dispatch(removeFromFavorite(favoriteItem))
    const currentProducts = JSON.parse(localStorage.getItem("favoriteItems"))
    let newProducts = []
    currentProducts.map(product => {
      newProducts.push({productId: product._id})
    })
    updateFavorite({_id: favorite._id, products: newProducts})
    .then(res => 
      {    
        toast('Product removed from favorites', {
          icon: '❌',
        });
  }).catch(err =>       {    
  })
  };

  const cartLs = useSelector(state => state.cart)
  
  const handleAddToCart = (product) => {
    console.log("PRODUCT IS", product)
    if(user?.accessToken && cart?._id) {


      let cartProduct = cartLs.cartItems.filter(function (el)
      {
        console.log("FOUND", el)
        return el._id === product._id
      })

      if(cartProduct.length === 0) {
        console.log("ADD NEW")
        let newProducts = []
        dispatch(addToCart(product))
        const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
        currentProducts.map(product => {
          newProducts.push({productId: product._id, quantity: product.cartQuantity})
        })
        console.log("Cart id", cart._id)
        console.log('products are', newProducts)
        updateCart({_id: cart._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => {
          console.log("res.data", res.data)
          toast.success('Product added to cart')
        })
        .catch(err => console.log("err", err))
      } else if(cartProduct[0].cartQuantity < product.quantity) {
        console.log("ADD EXISTENT")
        let newProducts = []
        dispatch(addToCart(product))
        const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
        console.log("ADD CURRENT PRODUCTS", currentProducts)
        currentProducts.map(product => {
          newProducts.push({productId: product._id, quantity: product.cartQuantity})
        })
        console.log("ADD NEW PRODUCTS", newProducts)
        console.log("Cart id", cart._id)
        updateCart({_id: cart._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => toast.success('Product added to cart'))
        .catch(err => console.log("err", err))
      } else {
        toast("You hitted our max stock for this product")
      }
    } else {
      toast.error("Please log in or register", {
        position: "bottom-left",
    })
    }
  }


  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));


  const mobileFavoriteItem = () => (
    <Card style={{display: 'flex', padding: '20px', justifyContent: 'space-between', alignItems:'center', width: '325px', height: '250px'}}>
    <div>
      <Image cloudName="deqqgmfxk"  publicId={item?.img} style={{width: '125px', height: '125px', objectFit:'cover', objectPosition:'center'}}/>
      <div style={{maxWidth: '150px'}}>
      <Typography gutterBottom variant="subtitle1" component="subtitle1" style={{textAlign: 'center'}}>
          {item?.title}
      </Typography>
      </div>
    </div>
  <div style={{display: 'flex', flexDirection:'column', alignItems: 'center', justifyContent:'center'}}>
    <Typography gutterBottom variant="subtitle1" component="subtitle1">
          ${item?.price}
    </Typography>
    <div style={{display:'flex', justifyContent:'space-between', flexDirection:'column'}}>
              <Button variant="outlined" type="button" color="primary" style={{width: '125px', margin:'10px'}} onClick={() => handleRemoveFromFavorite(item)}>Remove</Button>
              <Button variant="contained" type="button" color="primary" style={{width: '125px', margin:'10px'}} onClick={() => handleAddToCart(item)}>Add to cart</Button>
            </div>
  </div>
</Card>
)

  const tabletFavoriteItem = () => (
    <div style={{textAlign: 'center', paddingTop: '30px', fontSize: '12px', display: 'flex', justifyContent: 'space-between', width: '100%'}}>
      <Card style={{textAlign: 'center', paddingTop: '30px', fontSize: '12px', display: 'flex', justifyContent: 'center', width: '100%', margin: '0 30px'}}>
      <div >
        <Image cloudName="deqqgmfxk"  publicId={item?.img} style={{width: '250px', height: '250px', objectFit:'cover', objectPosition:'center'}}/>
        <div style={{maxWidth: '250px'}}>
        <Typography gutterBottom variant="h5" component="h5">
            {item?.title}
        </Typography>
        </div>
        <Typography gutterBottom variant="h5" component="h4">
            ${item?.price}
        </Typography>
      </div>
    <CardActions>
      <Button variant="contained" type="button" color="secondary" onClick={() => handleRemoveFromFavorite(item)} style={{width: '150px'}}>Remove</Button>
      <Button variant="contained" type="button" color="primary" style={{width: '150px'}} onClick={() => handleAddToCart(item)}>Add to cart</Button>
    </CardActions>
  </Card>
  </div>
)

  const desktopFavoriteItem = () => (
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems:'center', marginTop: '25px'}}>
         
          <div>
            <Image cloudName="deqqgmfxk"  publicId={item?.img} style={{width: '120px', height: '120px', objectFit:'cover', objectPosition:'center'}}/>
          </div>

          <div style={{display: 'flex', width:'300px', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
            <Typography gutterBottom variant="subtitle1" component="h2">
                {item?.title}
            </Typography>
            <div style={{display:'flex', justifyContent:'space-between'}}>
              <Button variant="outlined" type="button" color="primary" style={{width: '150px', marginRight:'20px'}} onClick={() => handleRemoveFromFavorite(item)}>Remove</Button>
              <Button variant="contained" type="button" color="primary" style={{width: '150px'}} onClick={() => handleAddToCart(item)}>Add to cart</Button>
            </div>

          </div>
          <div style={{width:'50px'}}>
            <Typography gutterBottom variant="subtitle1" component="h2">
                ${item?.price}
            </Typography>
          </div>
        </div>
  )
  
  return (
    (isXs | isSm) ?  mobileFavoriteItem() : 
    (isMd) ? tabletFavoriteItem() :
    desktopFavoriteItem()
  );
};

export default FavoriteItem;